import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import LdnDesignationForm from "./LdnDesignationForm";
import leo_logo from "~/images/leo_logo.png";

const LeoDesignations = ({ entities, setCompletedDesignations, vanityManufacturerName }) => {
  const manufacturer = "leo";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    leo: {},
  });

  useEffect(() => {
    setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  const sharedProps = {
    entities,
    manufacturer,
    vanityManufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
      productName={specialtyKeyName}
    />
  );

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={leo_logo} />
        </div>
        <div className="designation_form__section__header__title">{vanityManufacturerName}</div>
      </div>
      {renderDesignationForm(LdnDesignationForm, "adbry")}
    </div>
  );
};

export default LeoDesignations;
